import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputTimeComponent } from './input-time/input-time.component';

@NgModule({
  declarations: [InputTimeComponent],
  exports: [InputTimeComponent],
  imports: [CommonModule]
})
export class InputTimeModule { }
